<ul class="notification--list">
  @for (notification of notifications(); track notification.id) {
    <li class="list--item">
      <div class="notification--container" [class.new]="!notification.seen">
        <a
          class="notification--message title"
          [flNavRouterLink]="NAV_ROUTES.VESSEL.children.DETAILS"
          [flNavRouterLinkParams]="notification.vesselId"
        >
          <fl-icon
            class="notification--icon"
            [name]="notificationDropdownConfig[notification.priorityId].icon"
            [color]="notificationDropdownConfig[notification.priorityId].baseColor"
            size="20px"
          />
          <span class="notification--message--text">{{ notification.vesselName }}</span>
        </a>

        <a
          class="notification--message title"
          [flNavRouterLink]="NAV_ROUTES.FLEET.children.EVENTS"
          [flNavRouterLinkParams]="notification.id"
        >
          <span class="notification--message--text" [pTooltip]="notification.name | translate" flTooltipOverflowOnly>{{
            notification.name | translate
          }}</span>
        </a>
      </div>
    </li>
  } @empty {
    <span class="message">{{ "NOTIFICATIONS.MSG_NO_ACTIVE" | translate }}</span>
  }
</ul>
